import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API}/api`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const orgId = localStorage.getItem('crm_org_id');
  if (orgId) {
    config.headers['X-Org-Id'] = orgId;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isPortal = window.location.pathname.startsWith('/portail');
      window.location.href = isPortal ? '/portail' : '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
